import { useClassNames } from "@/utils/classNames";

import { Icon, StreamingIcons } from "../Icon";
import { PlayPauseButtonProps } from "./types";
import styles from "./PlayPauseButton.module.scss";

/**
 * Play/Pause button for video player controls
 *
 * @param props - The button properties
 * @returns the play/pause button component
 */
const PlayPauseButton = ({
  isPlaying,
  onClick,
  ariaLabel,
  className,
}: PlayPauseButtonProps) => {
  const cn = useClassNames(styles, styles["play-pause-button"], className);

  return (
    <button
      className={cn}
      onClick={onClick}
      aria-label={ariaLabel || (isPlaying ? "Pause" : "Play")}
      type="button"
    >
      {isPlaying ? (
        <Icon className={styles.icon} icon={StreamingIcons.Pause} />
      ) : (
        <Icon className={styles.icon} icon={StreamingIcons.Play} />
      )}
    </button>
  );
};

export { PlayPauseButton };
